import type * as Types from '../../../schemas/shopify/admin.types';

export type ProductAnalyticPageInfoNodeFragment = Pick<Types.Product, 'id' | 'title' | 'handle'>;

export const ProductAnalyticPageInfoNodeFragmentDoc = `
    fragment ProductAnalyticPageInfoNode on Product {
  id
  title
  handle
}
    `;
